/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from "react"
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    SlideProps,
} from "@mui/material"
import DialogService from "../../services/dialog"
import ComponentsUtils from "../../utils/components"
import { DialogType } from "../../models/dialog"
import UIService from "../../services/UIService"
import useMediaQuery from "@mui/material/useMediaQuery"

import CwText from "./cw-text"

const CwDialog = (): React.JSX.Element => {
    const isMobile = useMediaQuery("(max-width: 750px)")
    const [state, setParams] = useState<{
        isOpen: boolean
        transition: "left" | "right" | "up" | "down" | undefined
        title: string
        content: React.JSX.Element[]
        actionContent: React.JSX.Element[]
        showTitle?: boolean
        contentClassName?: string
        actionsClassName?: string
        dialogClassName?: string
        paperClassName?: string
        noClickAway?: boolean
    }>({
        isOpen: false,
        transition: undefined,
        title: "",
        content: [],
        actionContent: [],
        showTitle: true,
        contentClassName: "",
        actionsClassName: "",
        dialogClassName: "",
        paperClassName: "",
        noClickAway: false,
    })

    useEffect(() => {
        // init la SnackBar n s'abonnant aux Action de type SHOW
        DialogService.getInstance().subscribe(
            "all",
            DialogType.SHOW,
            "CwDialog",
            (param: any) => {
                setParams({
                    isOpen: !!param.isOpen,
                    transition: param.transition,
                    title: param.title,
                    actionContent: ComponentsUtils.initChildFieldsComponent(
                        param.actionContent
                    ),
                    content: ComponentsUtils.initChildFieldsComponent(
                        param.content
                    ),
                    showTitle:
                        typeof param.showTitle === "boolean"
                            ? param.showTitle
                            : true,
                    contentClassName: param.contentClassName,
                    actionsClassName: param.actionsClassName,
                    dialogClassName: param.dialogClassName,
                    paperClassName: param.paperClassName,
                    noClickAway: param.noClickAway,
                })
            }
        )
    }, [])

    /**
     * Envoie un event au Dialog pour qu'il se cache et clean son content
     */
    const handleClose = () => {
        if (state.noClickAway) return
        UIService.getInstance().hideDialog("CwDialog")
    }

    /**
     * Renvoie la bonne config de transition du Dialog
     * @param transition position de début de la transition
     * @returns Slide transition composant
     */
    const getTransition = (
        transition: "left" | "right" | "up" | "down" | undefined
    ) => {
        return React.forwardRef(function Transition(
            props: SlideProps,
            ref: React.Ref<unknown> | undefined
        ) {
            if (props.children)
                return <Slide direction={transition} ref={ref} {...props} />
            return null
        })
    }

    return (
        <Dialog
            className={state.dialogClassName}
            open={state.isOpen}
            hidden={!state.isOpen}
            TransitionComponent={
                state.transition ? getTransition(state.transition) : undefined
            }
            PaperProps={{
                style: {
                    width: "100%",
                    height: isMobile ? "calc(100vh - 100px)" : "auto",
                },
                className: state.paperClassName,
            }}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            {state.showTitle && (
                <DialogTitle id="alert-dialog-slide-title">
                    <CwText
                        name="textHeader"
                        type="text"
                        config={{
                            text: state.title,
                            className: "dialog-title",
                        }}
                    />
                </DialogTitle>
            )}

            <DialogContent className={state.contentClassName}>
                {state.content}
            </DialogContent>
            <DialogActions className={state.actionsClassName}>
                {state.actionContent}
            </DialogActions>
        </Dialog>
    )
}
export default CwDialog
